export default function LoadingSpinner() {
  return (
    <div className="absolute right-1/2 bottom-1/2 translate-x-1/2 translate-y-1/2">
      <div className="flex flex-col items-center">
        <div className="w-12 h-12 border-2 border-t-0 border-b-0 rounded-full animate-spin border-[#156ff7] dark:border-white" />
      </div>
    </div>
  );
}
